// Друзья в игре: с кем играли дружеский турнир по приглашению или кто пришёл по вашей ссылке.
// Контакты Telegram мини-приложению недоступны — это список из самой игры.

/** online — игра открыта сейчас; busy — играет турнир (вызов примет после него) */
export interface FriendDto {
  id: number;
  name: string;
  kit: string;
  online: boolean;
  busy: boolean;
  /** когда был в игре последний раз (ISO) */
  lastSeenAt: string | null;
}

/** GET /api/friends — сначала в сети */
export interface FriendsDto {
  friends: FriendDto[];
}

/** POST /api/tournaments/:id/invite-friend {friendId} — как дошёл вызов */
export interface InviteFriendResponse {
  /** game — всплыл в открытой игре; telegram — сообщение от бота; failed — не дошёл (бот не может написать) */
  delivered: 'game' | 'telegram' | 'failed';
}

/** Сокет: вызов от друга (ServerToClientEvents['invite:incoming']) */
export interface IncomingInviteDto {
  code: string;
  kind: 'DUEL' | 'FRIENDS';
  size: number;
  from: { id: number; name: string; kit: string };
}

/** «был 5 мин назад» */
export function lastSeenText(iso: string | null, now = Date.now()): string {
  if (!iso) return 'давно не заходил';
  const min = Math.max(0, Math.round((now - Date.parse(iso)) / 60_000));
  if (min < 1) return 'был только что';
  if (min < 60) return `был ${min} мин назад`;
  const h = Math.round(min / 60);
  if (h < 24) return `был ${h} ч назад`;
  const d = Math.round(h / 24);
  return d === 1 ? 'был вчера' : `был ${d} дн. назад`;
}
